import React from "react";
import { Partner, usePartnerContext } from ".";
import { USwitch } from "./Partners/USwitch";
import { Emma } from "./Partners/Emma";
import { Forbes } from "./Partners/Forbes";
import { BritishHomeSellers } from "./Partners/BritishHomeSellers";

interface IProps {
  children: React.ReactNode;
}

const PassThroughComponent = ({ children }: IProps) => <>{ children }</>;
PassThroughComponent.displayName = "PassThroughComponent";

const MAP_PARTNER_STYLES = {
  [Partner.NONE]: PassThroughComponent,
  [Partner.U_SWITCH]: USwitch,
  [Partner.EMMA]: Emma,
  [Partner.FORBES]: Forbes,
  [Partner.BRITISH_HOME_SELLERS]: BritishHomeSellers,
};

export const GlobalPartnerStyles = ({ children }: IProps) => {
  const partner = usePartnerContext();
  const PartnerTheme = MAP_PARTNER_STYLES[partner];

  return (
    <PartnerTheme>
      {children}
    </PartnerTheme>
  );
};
